import React from "react";
import styled from "@emotion/styled";
import BreadCrumbs from "../components/BreadCrumbs";
import TopBar from "../components/TopBar";
import { Route, Routes } from "react-router-dom";
import Home from "../pages/100/Home";
import Researches from "../pages/100/Researches";
import NewResearches from "../pages/100/NewResearches";
import StaffOverload from "../pages/100/StaffOverload";
import Settings from "../pages/100/Setting";
import Overload from "../pages/100/Overload";
import CoursePreference from "../pages/100/CoursePreference";
import Part_Time from "../pages/100/Part_Time";
import Extension from "../pages/100/Extension";
import ExtensionAgreement from "../pages/100/ExtensionAgreement";
import PartTimeAgreement from "../pages/100/PartTimeAgreement";
import ResearchManagementPage from "../pages/800/researchManagementPage";
import RequireAuth from "../components/RequireAuth";
import CourseManagment from "../pages/300/CourseManagment";
import RegisterCourse from "../pages/300/course/RegisterCourse";
import EditCourse from "../pages/300/course/EditCourse";
import CurriculumList from "../pages/300/curriculum";
import RegisterCurriculum from "../pages/300/curriculum/RegisterCurriculum";
import EditCurriculum from "../pages/300/curriculum/EditCurriculum";
import Hierarchy from "../pages/700/Hierarchy";
import AdminRoleAuthPage from "../pages/750/AdminRoleAuthPage";
import CourseReport from "../pages/600/CourseReport.js";
import BatchReport from "../pages/600/BatchReport";
import StaffReport from "../pages/600/StaffReport";
import CourseAssignment from "../pages/500/CourseAssignment";
import Display from "../pages/400/displayAll";
import UpdateBatch from "../pages/400/updateBatch";
import AddSemester from "../pages/400/addSemester";
import DisplaySemester from "../pages/400/displaySemester";
import UpdateSemester from "../pages/400/updateSemester";
import updateSection from "../pages/400/updateSection";
import RegisterBatch from "../pages/400/registerBatch";
import Constants from "../pages/400/constants";
import Position from "../pages/700/Position";
import PositionManagment from "../pages/700/PositionManagment";
import RegisterPosition from "../pages/700/RegisterPosition";
import OfficeManagment from "../pages/700/OfficeManagment";
import RegisterOffice from "../pages/700/RegisterOffice";
import EditOffice from "../pages/700/EditOffice";
import EditPosition from "../pages/700/EditPosition";
import UpdateSection from "../pages/400/updateSection";
import StaffManagement from "../pages/200/StaffManagment";
import RegisterStaff from "../pages/200/RegisterStaff";
import Dashbaord from "../pages/900/StaffDashboard";
import EditStaff from "../pages/200/EditStaff";
import StaffOverloadOffice from "../pages/1000/StaffOverloadOffice";
import Part_TimeOffice from "../pages/1000/Part_TimeOffice";
import ExtensionOffice from "../pages/1000/ExtensionOffice";
import PartTimeOfficeAgreement from "../pages/1000/PartTimeAgreement";
import ExtensionOfficeAgreement from "../pages/1000/ExtensionAgreement";
import OverloadOfficeAgreement from "../pages/1000/Overload";
import AgreementsOffice from "../pages/1000/Agreements";
import AgreementReport from "../pages/1000/AggreementReports";
import SystemSettings from "../pages/1100/SystemSetting";
import Log from "../pages/1200/log";

import ConfirmResearchMember from "../pages/100/ConfirmResearchMember";
import Agreements from "../pages/100/Agreements";

export default function RightComponents() {
  const RightComponents = styled.span`
    display: flex;
    flex-direction: column;
    justify-content: right;
    width: 100%;
  `;
  const Static = styled("span")(({ theme }) => ({
    position: "sticky",
    top: 0,
    background: theme.palette.background.default,
    zIndex: 3,
  }));

  return (
    <RightComponents>
      <Static>
        <TopBar />
        <BreadCrumbs />
      </Static>
      <Routes>
        <Route exact path="/*" element={<Home />} />
        <Route element={<RequireAuth allowedRoles={[104]} />}>
          <Route exact path="/researches" element={<Researches />} />
        </Route>
        <Route element={<RequireAuth allowedRoles={[104]} />}>
          <Route
            exact
            path="/researches/confirmMember/*"
            element={<ConfirmResearchMember />}
          />
        </Route>
        <Route element={<RequireAuth allowedRoles={[105]} />}>
          <Route
            exact
            path="/researches/new_researches"
            element={<NewResearches />}
          />
        </Route>
        {/* <Route element={<RequireAuth allowedRoles={[106]} />}>
          <Route exact path="/staff_overload" element={<StaffOverload />} />
        </Route>
        <Route element={<RequireAuth allowedRoles={[107]} />}>
          <Route
            exact
            path="/staff_overload/agreement"
            element={<Overload />}
          />
        </Route>
        <Route element={<RequireAuth allowedRoles={[108]} />}>
          <Route exact path="/part_time" element={<Part_Time />} />
        </Route>
        <Route element={<RequireAuth allowedRoles={[109]} />}>
          <Route
            exact
            path="/part_time/agreement"
            element={<PartTimeAgreement />}
          />
        </Route>
        <Route element={<RequireAuth allowedRoles={[110]} />}>
          <Route exact path="/extensions" element={<Extension />} />
        </Route>
        <Route element={<RequireAuth allowedRoles={[111]} />}>
          <Route
            exact
            path="/extensions/agreement"
            element={<ExtensionAgreement />}
          />
        </Route> */}
        <Route
          element={
            <RequireAuth allowedRoles={[106, 107, 108, 109, 110, 111]} />
          }
        >
          <Route exact path="/staff_agreements/*" element={<Agreements />} />
        </Route>
        <Route element={<RequireAuth allowedRoles={[112]} />}>
          <Route exact path="/offering/*" element={<CoursePreference />} />
        </Route>
        <Route element={<RequireAuth allowedRoles={[113]} />}>
          <Route exact path="/setting" element={<Settings />} />
        </Route>
        <Route element={<RequireAuth allowedRoles={[114]} />}>
          <Route exact path="/setting/security" element={<Settings />} />
        </Route>
        <Route element={<RequireAuth allowedRoles={[115]} />}>
          <Route exact path="/setting/appearances" element={<Settings />} />
        </Route>
        <Route path="staff_management">
          <Route index element={<StaffManagement />} />
          <Route path="addStaff" element={<RegisterStaff />} />
          <Route path="editStaff" element={<EditStaff />} />
        </Route>
        <Route path="course_management">
          <Route element={<RequireAuth allowedRoles={[302]} />}>
            <Route index element={<CourseManagment />} />
          </Route>
          <Route element={<RequireAuth allowedRoles={[303]} />}>
            <Route path="addCourse" element={<RegisterCourse />} />
          </Route>
          <Route element={<RequireAuth allowedRoles={[304]} />}>
            <Route path="editCourse" element={<EditCourse />} />
          </Route>
          <Route element={<RequireAuth allowedRoles={[351]} />}>
            <Route path="curriculumList" element={<CurriculumList />} />
          </Route>
          <Route element={<RequireAuth allowedRoles={[352]} />}>
            <Route path="addCurriculum" element={<RegisterCurriculum />} />
          </Route>
          <Route element={<RequireAuth allowedRoles={[353]} />}>
            <Route path="editCurriculum" element={<EditCurriculum />} />
          </Route>
        </Route>
        <Route path="calendar_management">
          <Route element={<RequireAuth allowedRoles={[400]} />}>
            <Route index element={<DisplaySemester />} />
          </Route>
          <Route element={<RequireAuth allowedRoles={[451]} />}>
            <Route path="addCalendar" element={<AddSemester />} />
          </Route>
          <Route element={<RequireAuth allowedRoles={[452]} />}>
            <Route path="updateCalendar" element={<UpdateSemester />} />
          </Route>
        </Route>
        <Route path="batch_management">
          <Route element={<RequireAuth allowedRoles={[451]} />}>
            <Route index element={<Display />} />
          </Route>
          <Route element={<RequireAuth allowedRoles={[401]} />}>
            <Route path="register" element={<RegisterBatch />} />
          </Route>
          <Route element={<RequireAuth allowedRoles={[402]} />}>
            <Route path="update" element={<UpdateBatch />} />
          </Route>
          <Route element={<RequireAuth allowedRoles={[404]} />}>
            <Route path="updateSection" element={<UpdateSection />} />
          </Route>
          <Route element={<RequireAuth allowedRoles={[404]} />}>
            <Route path="constants" element={<Constants />} />
          </Route>
        </Route>
        {/* <Route path="/register" element = {<Validate />} /> */}
        <Route element={<RequireAuth allowedRoles={[602]} />}>
          <Route path="/courseReport" element={<CourseReport />} />
        </Route>
        <Route element={<RequireAuth allowedRoles={[750]} />}>
          <Route path="/roles" element={<AdminRoleAuthPage />} />
        </Route>
        <Route element={<RequireAuth allowedRoles={[801]} />}>
          <Route
            exact
            path="/research_management"
            element={<ResearchManagementPage />}
          />
        </Route>
        <Route path="position_management">
          <Route element={<RequireAuth allowedRoles={[302]} />}>
            <Route index element={<PositionManagment />} />
          </Route>
          <Route element={<RequireAuth allowedRoles={[303]} />}>
            <Route path="addPosition" element={<RegisterPosition />} />
          </Route>
          <Route element={<RequireAuth allowedRoles={[303]} />}>
            <Route path="editPosition" element={<EditPosition />} />
          </Route>
        </Route>
        <Route path="office_management">
          <Route element={<RequireAuth allowedRoles={[302]} />}>
            <Route index element={<OfficeManagment />} />
          </Route>
          <Route element={<RequireAuth allowedRoles={[303]} />}>
            <Route path="addOffice" element={<RegisterOffice />} />
          </Route>
          <Route element={<RequireAuth allowedRoles={[303]} />}>
            <Route path="editOffice" element={<EditOffice />} />
          </Route>
          <Route element={<RequireAuth allowedRoles={[303]} />}>
            <Route path="addHierarchy" element={<Hierarchy />} />
          </Route>
        </Route>
        <Route element={<RequireAuth allowedRoles={[900]} />}>
          <Route exact path="/dashboard" element={<Dashbaord />} />
        </Route>
        <Route element={<RequireAuth allowedRoles={[500]} />}>
          <Route path="courseAssignment/*" element={<CourseAssignment />} />
        </Route>
        <Route element={<RequireAuth allowedRoles={[601]} />}>
          <Route path="staffReport" element={<StaffReport />} />
        </Route>
        <Route element={<RequireAuth allowedRoles={[600]} />}>
          <Route path="batchReport" element={<BatchReport />} />
        </Route>
        <Route element={<RequireAuth allowedRoles={[602]} />}>
          <Route path="courseReport" element={<CourseReport />} />
        </Route>
        <Route element={<RequireAuth allowedRoles={[1000, 1001, 1002]} />}>
          <Route
            exact
            path="/office_approval/*"
            element={<AgreementsOffice />}
          />
        </Route>
        <Route element={<RequireAuth allowedRoles={[1000,1001,1002]} />}>
          <Route
            exact
            path="/agreementReport/*"
            element={<AgreementReport />}
          />
        </Route>
        <Route element={<RequireAuth allowedRoles={[1100,1101,1102,1103]} />}>
          <Route
            exact
            path="/system_setting/*"
            element={<SystemSettings />}
          />
        </Route>
        <Route element={<RequireAuth allowedRoles={[1200, 1201, 1202]} />}>
          <Route exact path="/log/*" element={<Log />} />
        </Route>

        <Route element={<RequireAuth allowedRoles={[1000]} />}>
          <Route
            exact
            path="/staff_overloadOffice"
            element={<StaffOverloadOffice />}
          />
        </Route>
        <Route element={<RequireAuth allowedRoles={[1000]} />}>
          <Route
            exact
            path="/staff_overloadOffice/agreement"
            element={<OverloadOfficeAgreement />}
          />
        </Route>
        <Route element={<RequireAuth allowedRoles={[1001]} />}>
          <Route exact path="/part_timeOffice" element={<Part_TimeOffice />} />
        </Route>
        <Route element={<RequireAuth allowedRoles={[1001]} />}>
          <Route
            exact
            path="/part_timeOffice/agreement"
            element={<PartTimeOfficeAgreement />}
          />
        </Route>
        <Route element={<RequireAuth allowedRoles={[1002]} />}>
          <Route exact path="/extensionsOffice" element={<ExtensionOffice />} />
        </Route>
        <Route element={<RequireAuth allowedRoles={[1002]} />}>
          <Route
            exact
            path="/extensionsOffice/agreement"
            element={<ExtensionOfficeAgreement />}
          />
        </Route>

      </Routes>
    </RightComponents>
  );
}
